import { v4 as uuidV4 } from 'uuid';
const autofillAutomaticParams = () => ({
    xCorrelationId: uuidV4(),
});
export const autofillParams = (parameters, getAutofill) => {
    return {
        ...autofillAutomaticParams(),
        ...getAutofill(),
        ...parameters,
    };
};
